import PropTypes from 'prop-types';
import React from 'react';
import FlexBox from 'flexbox-react';
import { CardText } from 'react-toolbox';
import styles from './styles.scss';

const UserDetailsRow = ({ title, subtitle, children }) =>
  <CardText className={styles.row}>
    <div className={styles.titleWrapper}>
      <h2 className={styles.titleRow}>{title}</h2>
      {subtitle}
    </div>
    <FlexBox justifyContent="space-between">
      <FlexBox className={styles.flexFullWidth}>
        {children}
      </FlexBox>
    </FlexBox>
  </CardText>;

UserDetailsRow.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export default UserDetailsRow;



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserDetailsRow/index.jsx